<template>
  <div class="page-wrapper">
    <!-- ===================== PC版（折叠搜索栏） ===================== -->
    <div class="pc-version">
      <div
        class="user-prize-log-container"
        v-loading="loading"
        element-loading-text="加载中..."
      >
        <!-- PC 搜索栏（折叠版） -->
        <div
          class="search-bar"
          style="
            margin-bottom: 20px;
            display: flex;
            gap: 10px;
            align-items: center;
            flex-wrap: wrap;
          "
        >
          <div class="search-collapse-btn" @click="toggleSearch">
            <i
              class="el-icon-arrow-down"
              :class="{ 'el-icon-arrow-up': !searchCollapsed }"
            ></i>
            {{ searchCollapsed ? "展开搜索" : "收起搜索" }}
          </div>
          <div
            :style="{
              display: searchCollapsed ? 'none' : 'flex',
              gap: '10px',
              alignItems: 'center',
            }"
          >
            <el-input
              v-model="searchParams.user_id"
              placeholder="用户ID"
              style="width: 160px"
              clearable
            ></el-input>
          </div>
          <div style="display: flex; gap: 10px; margin-left: 10px">
            <el-button type="primary" @click="getList">搜索</el-button>
            <el-button @click="resetSearch">重置</el-button>
          </div>
        </div>

        <el-table
          :data="tableData"
          border
          stripe
          style="width: 100%"
          @row-click="handleRowClick"
        >
          <el-table-column label="ID" prop="id" width="80" align="center" />
          <el-table-column
            label="用户ID"
            prop="user_id"
            width="120"
            align="center"
          />
          <el-table-column label="盲盒名称" prop="box_name" min-width="150" />
          <!-- 赏袋图片 -->
          <el-table-column label="赏袋图片" width="100" align="center">
            <template slot-scope="scope">
              <el-image
                :src="scope.row.box_image"
                fit="cover"
                style="width: 50px; height: 50px; border-radius: 4px; cursor: pointer"
                :preview-src-list="[scope.row.box_image]"
              ></el-image>
            </template>
          </el-table-column>
          <el-table-column label="奖品名称" prop="box_prize_name" min-width="160" />
          <!-- 奖品图片 -->
          <el-table-column label="奖品图片" width="100" align="center">
            <template slot-scope="scope">
              <el-image
                :src="scope.row.box_prize_image"
                fit="cover"
                style="width: 50px; height: 50px; border-radius: 4px; cursor: pointer"
                :preview-src-list="[scope.row.box_prize_image]"
              ></el-image>
            </template>
          </el-table-column>
          <el-table-column label="奖品等级" prop="box_prize_level" width="100" align="center" />
          <el-table-column label="价值" prop="price" width="100" align="center" />
          <el-table-column label="回收价" prop="recovery_price" width="100" align="center" />
          <el-table-column label="数量" prop="num" width="80" align="center" />
          <el-table-column
            label="状态"
            width="100"
            align="center"
          >
            <template slot-scope="scope">
              <el-tag type="success" v-if="scope.row.status === 1">正常</el-tag>
              <el-tag type="danger" v-else>异常</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" prop="created_at" width="180" />
          <el-table-column label="更新时间" prop="updated_at" width="180" />
        </el-table>

        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchParams.page"
          :page-size="searchParams.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          style="margin-top: 20px; text-align: right"
        ></el-pagination>

        <el-dialog
          title="赏袋日志详情"
          :visible.sync="detailVisible"
          width="700px"
          append-to-body
        >
          <el-form :model="detailForm" label-width="130px" size="small">
            <el-form-item label="日志ID"><span>{{ detailForm.id }}</span></el-form-item>
            <el-form-item label="用户ID"><span>{{ detailForm.user_id }}</span></el-form-item>
            <el-form-item label="商品ID"><span>{{ detailForm.goods_id }}</span></el-form-item>
            <el-form-item label="赏袋ID"><span>{{ detailForm.box_id }}</span></el-form-item>
            <el-form-item label="盲盒名称"><span>{{ detailForm.box_name }}</span></el-form-item>
            <!-- 赏袋图片 -->
            <el-form-item label="赏袋图片">
              <el-image
                :src="detailForm.box_image"
                fit="cover"
                style="width: 80px; height: 80px; border-radius: 4px"
                :preview-src-list="[detailForm.box_image]"
              ></el-image>
            </el-form-item>
            <el-form-item label="奖品ID"><span>{{ detailForm.box_prize_id }}</span></el-form-item>
            <el-form-item label="奖品名称"><span>{{ detailForm.box_prize_name }}</span></el-form-item>
            <!-- 奖品图片 -->
            <el-form-item label="奖品图片">
              <el-image
                :src="detailForm.box_prize_image"
                fit="cover"
                style="width: 80px; height: 80px; border-radius: 4px"
                :preview-src-list="[detailForm.box_prize_image]"
              ></el-image>
            </el-form-item>
            <el-form-item label="奖品等级"><span>{{ detailForm.box_prize_level }}</span></el-form-item>
            <el-form-item label="订单ID"><span>{{ detailForm.box_order_id }}</span></el-form-item>
            <el-form-item label="价值"><span>{{ detailForm.price }} 元</span></el-form-item>
            <el-form-item label="回收价格"><span>{{ detailForm.recovery_price }} 元</span></el-form-item>
            <el-form-item label="亏损价格"><span>{{ detailForm.loss_price }} 元</span></el-form-item>
            <el-form-item label="数量"><span>{{ detailForm.num }}</span></el-form-item>
            <el-form-item label="状态"><span>{{ detailForm.status === 1 ? '正常' : '异常' }}</span></el-form-item>
            <el-form-item label="创建时间"><span>{{ detailForm.created_at }}</span></el-form-item>
            <el-form-item label="更新时间"><span>{{ detailForm.updated_at }}</span></el-form-item>
          </el-form>
          <div slot="footer" style="text-align: right">
            <el-button @click="detailVisible = false">关闭</el-button>
          </div>
        </el-dialog>
      </div>
    </div>

    <!-- ===================== 移动端（折叠搜索栏） ===================== -->
    <div class="mobile-version">
      <div
        class="mobile-container"
        v-loading="loading"
        element-loading-text="加载中..."
      >
        <!-- 移动端搜索栏（折叠版） -->
        <div class="mobile-search">
          <div class="mobile-search-collapse" @click="toggleSearch">
            {{ searchCollapsed ? "展开搜索条件 ▼" : "收起搜索条件 ▲" }}
          </div>
          <div
            v-if="!searchCollapsed"
            style="display: flex; flex-direction: column; gap: 8px"
          >
            <el-input
              v-model="searchParams.user_id"
              placeholder="用户ID"
              clearable
              size="medium"
            ></el-input>
          </div>
          <div style="display: flex; gap: 8px; margin-top: 10px">
            <el-button
              type="primary"
              plain
              round
              style="flex: 1"
              @click="getList"
              >搜索</el-button
            >
            <el-button plain round style="flex: 1" @click="resetSearch"
              >重置</el-button
            >
          </div>
        </div>

        <div class="mobile-card-list">
          <div
            class="mobile-card"
            v-for="item in tableData"
            :key="item.id"
            @click="handleRowClickMobile(item)"
          >
            <div class="card-top">
              <div class="label">{{ item.box_name }} → {{ item.box_prize_name }}</div>
              <el-tag type="success" size="mini" v-if="item.status === 1">正常</el-tag>
              <el-tag type="danger" size="mini" v-else>异常</el-tag>
            </div>
            <!-- 移动端图片展示 -->
            <div class="card-images" style="display: flex; gap: 10px; margin: 10px 0">
              <div style="text-align: center">
                <el-image
                  :src="item.box_image"
                  fit="cover"
                  style="width: 60px; height: 60px; border-radius: 6px"
                  :preview-src-list="[item.box_image]"
                ></el-image>
                <div style="font-size: 12px; color: #999; margin-top: 4px">赏袋</div>
              </div>
              <div style="text-align: center">
                <el-image
                  :src="item.box_prize_image"
                  fit="cover"
                  style="width: 60px; height: 60px; border-radius: 6px"
                  :preview-src-list="[item.box_prize_image]"
                ></el-image>
                <div style="font-size: 12px; color: #999; margin-top: 4px">奖品</div>
              </div>
            </div>
            <div class="card-body">
              <div><span>用户ID：</span>{{ item.user_id }}</div>
              <div><span>奖品等级：</span>{{ item.box_prize_level }}级</div>
              <div><span>价值：</span>{{ item.price }} 元</div>
              <div><span>数量：</span>{{ item.num }}</div>
              <div><span>创建时间：</span>{{ item.created_at }}</div>
              <div><span>更新时间：</span>{{ item.updated_at }}</div>
            </div>
          </div>
        </div>

        <div style="text-align: center; margin-top: 15px">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="searchParams.page"
            :page-size="searchParams.page_size"
            layout="prev, pager, next, total"
            :total="total"
            pager-count="2"
            small
          />
        </div>

        <el-dialog
          title="赏袋日志详情"
          :visible.sync="detailVisibleMobile"
          width="90%"
          top="8vh"
          custom-class="mobile-dialog"
          append-to-body
        >
          <el-form :model="detailForm" label-width="100px" size="small">
            <el-form-item label="日志ID"><span>{{ detailForm.id }}</span></el-form-item>
            <el-form-item label="用户ID"><span>{{ detailForm.user_id }}</span></el-form-item>
            <el-form-item label="盲盒名称"><span>{{ detailForm.box_name }}</span></el-form-item>
            <!-- 移动端详情图片 -->
            <el-form-item label="赏袋图片">
              <el-image
                :src="detailForm.box_image"
                fit="cover"
                style="width: 70px; height: 70px; border-radius: 4px"
                :preview-src-list="[detailForm.box_image]"
              ></el-image>
            </el-form-item>
            <el-form-item label="奖品名称"><span>{{ detailForm.box_prize_name }}</span></el-form-item>
            <el-form-item label="奖品图片">
              <el-image
                :src="detailForm.box_prize_image"
                fit="cover"
                style="width: 70px; height: 70px; border-radius: 4px"
                :preview-src-list="[detailForm.box_prize_image]"
              ></el-image>
            </el-form-item>
            <el-form-item label="奖品等级"><span>{{ detailForm.box_prize_level }}</span></el-form-item>
            <el-form-item label="价值"><span>{{ detailForm.price }} 元</span></el-form-item>
            <el-form-item label="数量"><span>{{ detailForm.num }}</span></el-form-item>
            <el-form-item label="状态"><span>{{ detailForm.status === 1 ? '正常' : '异常' }}</span></el-form-item>
            <el-form-item label="创建时间"><span>{{ detailForm.created_at }}</span></el-form-item>
            <el-form-item label="更新时间"><span>{{ detailForm.updated_at }}</span></el-form-item>
          </el-form>
          <div slot="footer" style="text-align: right">
            <el-button @click="detailVisibleMobile = false">关闭</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../api/api.js";

export default {
  name: "UserPrizeLogs",
  data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      // 搜索参数
      searchParams: {
        page: 1,
        page_size: 10,
        user_id: "",
      },
      // 弹窗
      detailVisible: false,
      detailVisibleMobile: false,
      detailForm: {},
      // 搜索折叠
      searchCollapsed: true,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 获取赏袋日志列表
    async getList() {
      this.loading = true;
      try {
        const res = await api.users.userPrizeLogs({
          params: this.searchParams,
        });
        if (res.data.code == 1000) {
          this.tableData = res.data.data.data;
          this.total = res.data.data.total;
        }
      } finally {
        this.loading = false;
      }
    },

    // PC 点击行查看详情
    handleRowClick(row) {
      this.detailForm = { ...row };
      this.detailVisible = true;
    },

    // 移动端点击查看详情
    handleRowClickMobile(row) {
      this.detailForm = { ...row };
      this.detailVisibleMobile = true;
    },

    // 重置搜索
    resetSearch() {
      this.searchParams = {
        page: 1,
        page_size: 10,
        user_id: "",
      };
      this.getList();
    },

    // 每页条数改变
    handleSizeChange(val) {
      this.searchParams.page_size = val;
      this.getList();
    },

    // 页码改变
    handleCurrentChange(val) {
      this.searchParams.page = val;
      this.getList();
    },

    // 折叠/展开搜索栏
    toggleSearch() {
      this.searchCollapsed = !this.searchCollapsed;
    },
  },
};
</script>

<style scoped>
.user-prize-log-container {
  padding: 20px;
}
.mobile-container {
  padding: 12px;
  box-sizing: border-box;
}
.mobile-search {
  background: #fff;
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 10px;
}
.mobile-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.mobile-card {
  background: #fff;
  border-radius: 12px;
  padding: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.card-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.card-top .label {
  font-size: 15px;
  font-weight: 500;
}
.card-body {
  font-size: 13px;
  color: #666;
  line-height: 1.8;
}
.card-body span {
  color: #999;
}
</style>


// WEBPACK FOOTER //
// src/pages/user/prizeLog.vue